import { useCallback, useState } from 'react'

/** 游标分页状态，上一页通过回退游标实现 */
export function useCursorPager() {
  const [cursors, setCursors] = useState<string[]>([''])
  const [total, setTotal] = useState<number | undefined>()

  const next = useCallback((nextCursor: string) => {
    if (nextCursor) setCursors(stack => [...stack, nextCursor])
  }, [])
  const prev = useCallback(() => {
    setCursors(stack => (stack.length > 1 ? stack.slice(0, -1) : stack))
  }, [])
  const reset = useCallback(() => {
    setCursors([''])
    setTotal(undefined)
  }, [])

  const cursor = cursors[cursors.length - 1]
  return {
    cursor,
    page: cursors.length,
    isFirstPage: cursors.length === 1,
    total,
    setTotal,
    next,
    prev,
    reset
  }
}
